import { Routes, Route, Navigate } from 'react-router-dom';
import { TaskInboxPage } from './pages';

/**
 * Tasks domain — the Work Surface HITL task inbox.
 */
const Tasks = () => (
  <Routes>
    <Route index element={<TaskInboxPage />} />
    <Route path="*" element={<Navigate to="" replace />} />
  </Routes>
);

export default Tasks;
